import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const ActivityFieldsSummary = ({ t, activityFields }) => {
  const mainActivityField = activityFields.filter(item => item.defaultActivity === true);
  return (
    <Grid container spacing={1}>
      <Grid item xs={4} sm={4} md={6}>
        <strong>{mainActivityField && mainActivityField.length > 0 ? t('OfferEdit.Client.ActivityFields.CAENCode') + ' : ' : ' '}</strong>
        <span>
          {mainActivityField && mainActivityField.length > 0
            ? `${mainActivityField[0].activityFieldCode || ''} ${mainActivityField[0].activityFieldName || ''}`
            : ''}
        </span>
      </Grid>
    </Grid>
  );
};

ActivityFieldsSummary.propTypes = {
  activityFields: PropTypes.array,
  t: PropTypes.func.isRequired
};

export default withTranslation()(ActivityFieldsSummary);
